// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import {
  CommercialAgreementOffer,
  CommercialAgreementOffer_Reject_Result,
} from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/Offer';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { useParties } from '../../../contexts/PartiesContext';

export const useRejectCommercialAgreementOffer: () => UseMutationResult<
  CommercialAgreementOffer_Reject_Result,
  string,
  {
    commercialAgreementOfferCid: ContractId<CommercialAgreementOffer>;
    reason: string;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { party } = useParties();

  return useMutation({
    mutationKey: ['rejectCommercialAgreementOffer', ledgerApi, party],
    mutationFn: async ({ commercialAgreementOfferCid, reason }) => {
      return ledgerApi.rejectCommercialAgreementOffer(commercialAgreementOfferCid, reason);
    },
  });
};
